export default "__VITE_ASSET__CVbLoegt__"